import { useState, useEffect } from 'react';
import { useTheme } from '../context/theme';
import { api } from '../utils/api';
import { renderIcon } from '../utils/icons';
import { Card, PP } from './ui';

export default function TasksDueSoon() {
  const { theme, isDark } = useTheme();
  const [items, sI] = useState([]);
  const [ld, sL] = useState(true);

  useEffect(() => {
    api.get('/api/stats/due-soon').then(d => { sI((d.items || []).slice(0, 8)); sL(false); }).catch(() => sL(false));
  }, []);

  const dc = d => {
    if (!d) return theme.textSecondary;
    const days = (new Date(d) - new Date()) / 864e5;
    return days <= 2 ? '#EF4444' : days <= 5 ? '#F59E0B' : theme.textSecondary;
  };

  return (
    <Card>
      <div style={{ fontSize: 16, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", letterSpacing: '-0.01em', color: theme.text, marginBottom: 14 }}>Due This Week</div>
      {ld ? (
        <div style={{ color: theme.textSecondary, fontSize: 13 }}>Loading...</div>
      ) : items.length === 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '16px 0', textAlign: 'center' }}>
          <div style={{ fontSize: 28, marginBottom: 6 }}>{renderIcon('check-circle', 24, theme.accent)}</div>
          <div style={{ fontSize: 14, color: theme.textSecondary }}>Nothing due this week</div>
        </div>
      ) : (
        items.map((it, i) => (
          <div key={it.id || i} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '7px 0', borderBottom: i < items.length - 1 ? `1px solid ${theme.border}` : 'none'
          }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, color: theme.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.doc}</div>
              <div style={{ fontSize: 12, color: theme.textSecondary }}>{it.site_name}</div>
            </div>
            <div style={{ fontSize: 12, color: dc(it.due_date), marginLeft: 10, flexShrink: 0 }}>
              {it.due_date ? new Date(it.due_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : ''}
            </div>
            <PP p={it.priority} />
          </div>
        ))
      )}
    </Card>
  );
}
